export class Formation {
  campagne_id: string;
  agent_id: string;
  catalogue_formation_id: string;
  priorite: string;
  lieu: string;
  periode_souhaite: string;
  periode_evaluation_poste_formation: string;
  motivation: string;
  mesure_efficacite: string;
  duree_souhaite: string;
  intitule_formation: string;
  type_intitule_formation: string;
  budget: string;
  constructor(campagne_id: string, agent_id: string, catalogue_formation_id: string, priorite: string, lieu: string, periode_souhaite: string,
  periode_evaluation_poste_formation: string, motivation: string, mesure_efficacite: string, duree_souhaite: string, type_intitule_formation: string,
              intitule_formation: string, budget: string ) {
    this.campagne_id = campagne_id;
    this.agent_id = agent_id;
    this.catalogue_formation_id = catalogue_formation_id;
    this.priorite = priorite;
    this.lieu = lieu;
    this.periode_souhaite = periode_souhaite;
    this.periode_evaluation_poste_formation = periode_evaluation_poste_formation;
    this.motivation = motivation;
    this.mesure_efficacite = mesure_efficacite;
    this.duree_souhaite = duree_souhaite;
    this.type_intitule_formation = type_intitule_formation;
    this.intitule_formation = intitule_formation;
    this.budget = budget;
  }
}
